import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authManager } from '@df/api';
import { useAuthReady } from '../contexts/AuthReadyContext';
import { CircularProgress } from '@mui/material';
import { AUTH_BYPASS_DEV } from '../config/featureFlags';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { authReady } = useAuthReady();
  const isSuspect = authManager.isSuspect?.() === true;

  // Wait for auth to be ready before making decisions
  if (!authReady) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (AUTH_BYPASS_DEV) {
    return children;
  }
  
  // Token-presence based decision (no network calls, no validation)
  const isAuthedByToken = !!authManager.getAccessToken();

  if (isSuspect) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: '0 16px', textAlign: 'center', gap: '8px' }}>
        <div style={{ fontSize: '18px', fontWeight: 600 }}>Session validation failed</div>
        <div style={{ fontSize: '14px', color: '#666' }}>Unable to confirm your session with the backend. Please retry.</div>
      </div>
    );
  }

  if (!isAuthedByToken) {
    // Redirect to login page with return url
    const from = `${location.pathname}${location.search || ''}${location.hash || ''}`;
    return <Navigate to="/login" state={{ from }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;
